import { Expose } from "class-transformer";

export class UpdateClientPaymentMethodDto {
  @Expose()
  name: string;

  @Expose()
  id: string;
}
